const THEMES = ['aurora', 'deep', 'mint'] as const;
export type Theme = (typeof THEMES)[number];

export const isTheme = (value: unknown): value is Theme => THEMES.includes(value as Theme);

export function getActiveTheme(root: HTMLElement = document.documentElement): Theme {
  return THEMES.find((theme) => root.classList.contains(`t-${theme}`)) ?? 'aurora';
}

export function setThemeClass(theme: Theme, root: HTMLElement = document.documentElement): void {
  THEMES.forEach((t) => {
    root.classList.remove(`t-${t}`);
  });
  root.classList.add(`t-${theme}`);
}

/** Heroes render on a dark background in every theme except Aurora. */
export const isHeroDark = (): boolean => getActiveTheme() !== 'aurora';
